module.exports = __webpack_public_path__ + "img/ctrl-p-stub-down-0.3455f739.svg";